import React, {useEffect, useState} from 'react';
import {
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  LinearProgress,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
  Tooltip,
  Typography
} from '@material-ui/core'
import './styles.scss'
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import {notification, stats} from '../../assets/images/images';
import HttpService from "../../services/http.service";
import {getUserDataFromLocalStorage} from "../../services/utils";
import axios from "axios"
import {Loader, OrdersDataTable} from '../index';
import Weather from './weather'
import {bidsHeadCellsSmart} from '../../container/dashboard/bidsAgainstHarvest/constant'
import DataTable from '../dataTable/servicesSelectionDatatable'
import {bidsAgainst} from "../../environment";
import Alert from "../alert";

const CustomCard = (props) => {
  return (
    <Card style={{width: '120px'}} elevation={1} className='pb-0 ml-20 mt-10 pt-0 homepage-card'>
      <CardContent className='display-flex flex-column align-items-center text-capitalize text-center'
                   style={{padding: 0}}>
        <h2 className='heading-color'>{props.value}</h2>
        <Divider className='full-width'/>
        <p className='mt-10 mb-5'>{props.text}</p>
      </CardContent>
    </Card>
  )
}

const ProgressCard = (props) => {
  return (
    <Card className='mt-10 ml-10' elevation={1} style={{flexGrow: 1}}>
      <CardContent className='display-flex flex-column'>

        <div className='display-flex justify-content-between'>
          <span>Bids / Order </span>
          <img src={stats} alt={''} className='ml-10 '/>
        </div>

        <div className='display-flex align-items-center flex-column align-self-end'>

          {/* <p className='text-bold heading-color m-0'>PKR 340</p> */}
        </div>
        <div className=' mb-5'>
          {/*<span> Respond to bids 3 from 6</span>*/}
          <span><b> {props.bid}</b> Bids placed : <b>{props.order}</b> Order placed</span>
          <LinearProgress className='mt-5 mb-10' variant="determinate" value={0}/>
        </div>
      </CardContent>
    </Card>
  )
}


const headCells = [
  {id: "orderNumber", numeric: false, disablePadding: true, label: "order #"},
  {id: "orderGroupNumber", numeric: false, disablePadding: false, label: "order Group #"},
  {id: "bidDate", numeric: false, disablePadding: false, label: "bid Date",},
  {id: "harvestUnitPrice", numeric: true, disablePadding: false, label: "Price"},
];
const data = [2, 2, 2, 22, 2, 2, 2, 22, 2];

function Dashboard(props) {
  const user = getUserDataFromLocalStorage()
  const [dashboard, setDashboard] = useState([])
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(true)
  const [weather, setWeather] = useState([])
  const [alerts, setAlerts] = useState([])
  const verified = JSON.parse(localStorage.getItem("verification"));
  const [bid, setBid] = useState([])
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  useEffect(() => {
    if (!user) {
      props.history.push("/");
    } else
      HttpService.get('dashbaord/ssoId/' + user.ssoId).then(res => {
        if (res && res.data) {
          setDashboard(res?.data?.data)
          // setLoading(false)
        }
      });
    // orders/listAllActiveorders/ssoId/{ssoId}
    HttpService.get('api/orders/listAllActiveordersForMe/ssoId/' + user.ssoId).then(res => {
      if (res && res.data) {
        setOrders(res?.data)
        // setLoading(false)
      }

    });
    HttpService.post('bids/getMyBids/', {ssoId: user.ssoId}).then(res => {
      if (res) {
        setBid(res.data)
      }
    });
    fetch('https://geolocation-db.com/json/')
        .then((res) => res.json())
        .then(res => {
      if (res && res?.data) {
        HttpService.setToken(res.data?.country_code)
        localStorage.setItem("ip", JSON.stringify(res?.data))
        HttpService.get('api/weather/getWeather-' + (res.data.city ? res.data.city.toLowerCase() : "islamabad")).then(res => {
          if (res) {
            setWeather(res?.data?.list)
            setLoading(false)
          }
        });
      } else {
        console.log('hi not data ')
      }

    }).catch(res=>console.log(res))
  }, []);
  useEffect(() => {
    if (!user) {
      props.history.push("/");
    } else
      HttpService.get('api/list/V2/alerts/ssoId/' + user.ssoId).then(res => {
        if (res) {
          setAlerts(res.data)
        }
      });
  }, []);
  return (
    <Grid container direction={'column'} className='pl-20 pr-20 pt-20' style={{minHeight: 500,}}>
      {((error || success)) && <Alert type={error ? 'error' : 'success'} message={error || success}/>}
      <Grid item>
        <Grid container justify='space-between'>
          <Grid item className='display-flex align-items-center'>
            <h3 className='text-capitalize black-color mt-5 mb-5'>hello {user?.firstName} {user?.lastName} </h3>
            {/*<p className='not-premium ml-10 font-12  text-bold text-capitalize'>not verified</p>*/}
            {verified && verified.messageText == "User verification Status OK" &&
            <Tooltip title={'email and number verified'}>

              <p className='premium ml-10 font-12  text-bold text-capitalize'>verified</p>
            </Tooltip>}
            {verified && verified.messageText == "Verification Status not updated" &&
            <Tooltip title={'email and number not verified'}>
              <p className='not-premium ml-10 font-12  text-bold text-capitalize'>not verified</p>
            </Tooltip>}
            {!verified && <Tooltip title={'email and number not verified'}>
              <p className='not-premium ml-10 font-12  text-bold text-capitalize'>not verified</p>
            </Tooltip>}
            {!verified &&  <button className="custom-btn btn-3 mt-10 mb-10" onClick={()=>{
              let url = `api/userVerification?verificationMedia=email&verificationStatus=Y&userId.ssoId=${user.ssoId}`
              HttpService.post(url).then(res => {
                if (res) {
                  if (res?.data?.message === "MSG")
                    setSuccess("Verification Email is send! please check your email inbox")
                  setTimeout(() => {
                    setSuccess("")
                  }, 9000);
                } else
                  setError(res?.data?.messageText)
                setTimeout(() => {
                  setError("")
                }, 9000);
              });
            }
            }><span>Verify</span></button>}
          </Grid>
        </Grid>
      </Grid>
      {/*cards container*/}
      <Grid container direction={'row'} style={{background: '',}}>
        <ProgressCard order={orders && orders.length} bid={bid && bid.length}/>
        <CustomCard text={'acceted'} value={dashboard.acceted || 0}/>
        <CustomCard text={'rejected'} value={dashboard.rejected || 0}/>
        <CustomCard text={' Orders Received'} value={dashboard.totalOrders || 0}/>
        <CustomCard text={'total Products'} value={dashboard.totalProducts || 0}/>
        {/*<CustomCard text={'location'} value={dashboard.acceted || 0}/>*/}
      </Grid>

      {/*graph container*/}
      <Grid container className='mt-20 mb-20' style={{flexWrap: 'wrap', backgroundColor: '', padding: 0}}>
        {/*<div className='display-flex flex-wrap'>*/}
        <Grid item lg={8} md={12} sm={12} className='mt-20 overflow-auto'>
          <Paper elevation={2}>
            <h2 className='mt-0 p-10 pb-0'>Recent Orders</h2>
            <Grid style={{maxHeight: 258}} className='overflow-auto'>

              <OrdersDataTable data={{rows: orders, column: headCells, smart: true}}/>

            </Grid>
            <h2 className='mt-0 p-10 pb-0'>Recent Bids</h2>
            <Grid style={{maxHeight: 280}} className='overflow-auto'>
              <DataTable
                // data={{rows: usersList?.resp, column: headCells,}}
                // data={{rows: data, column: servicesHeadCells,}}
                data={{rows: bid, column: bidsHeadCellsSmart}}
                // vendor={activeCat === 'vendor'}
                tableName={bidsAgainst}
                smart={true}
                showAddOption={false}
              />
            </Grid>
            <Grid item className=' mt-20' style={{}}>

              {/*<Paper elevation={2} className='mb-20 mt-20 '>*/}
              <div className='mr-30 mt-20'>
                {loading && <Loader></Loader>}
                {weather && weather.length && <Weather weather={weather}/>}
              </div>
              {/*</Paper>*/}

            </Grid>

            {/*<Grid container spacing={1} alignItems={'stretch'} lg={12} md={12} sm={12} style={{backgroundColor: ''}}*/}
            {/*      className='10 mt-20  '>*/}
            {/*  /!*<Grid item lg={7} md={7} sm={12}>*!/*/}
            {/*  /!*  <HomeLineChart/>*!/*/}
            {/*  /!*</Grid>*!/*/}
            {/*  /!*<Grid item lg={5} md={5} sm={12} style={{backgroundColor: ''}}>*!/*/}
            {/*  /!*  <MyCalender/>*!/*/}
            {/*  /!*</Grid>*!/*/}
            {/*</Grid>*/}
            {/*<div className='mr-30 mt-20'>*/}
            {/*  {loading && <Loader></Loader>}*/}
            {/*  {weather && weather.length && <Weather weather={weather}/>}*/}
            {/*</div>*/}
          </Paper>
        </Grid>
        <Grid item lg={4} md={12} sm={12} xs={12} className=' mt-20' style={{}}>
          <Paper elevation={2} className=' p-20 pt-0 pb-0 ml-10 ' style={{height: 500}}>
            <div className='display-flex align-items-center flex-wrap justify-content-between'>
              <h4 className=' mb-5'>News</h4>
              <div className='display-flex align-items-center'>
                <span className='heading-color text-bold'>Help Agri Family </span>
                <img src={notification} alt={''} className='ml-10 mt-5'/>
              </div>
            </div>
            <Typography variant={'p'} className='in-active-color font-14 pb-10'>Global</Typography>
            <List style={{maxHeight: 400, overflow: 'auto'}} className='homepage-list-item'>
              {alerts.map((item, index) => {
                return (
                  <>
                    <ListItem className='pl-0 pr-0 flex-wrap display-flex'>
                      <ListItemText primary={item.alertTxt}
                                    style={{maxWidth: '75%'}}/>
                      <ListItemSecondaryAction className='p-0'>
                        <IconButton edge="end" aria-label="delete" className='p-0 ml-5'>
                          <InsertDriveFileIcon/>
                          <button className='ml-20 alert-btn ' style={{backgroundColor: ''}}>ALERT</button>
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider className='full-width'/>
                  </>
                )
              })}
            </List>
          </Paper>
          <Paper elevation={2} className='mb-20 mt-20 '>
            <CardContent className='text-center'>
              <h3 className='mt-5 black-color'>AgriLive Market Place</h3>
              <Divider/>
              <p className='in-active-color pb-10 font-12'>Version 1.0</p>
            </CardContent>
          </Paper>

        </Grid>
        {/*</div>*/}
      </Grid>


    </Grid>
  );
}

export default Dashboard;
